import { defineMessages } from "./define";

export const shellMessages = defineMessages({
  ru: {
    "header.search_mode": "Искать по",
    "header.search_examples": "Примеры поиска",
    "header.search_all": "Всё",
    "header.search_price": "Цена",
    "header.search_number": "№ NFT",
    "header.search_all_hint": "Название коллекции, цена или #номер NFT",
    "header.search_price_hint": "Введите цену в валюте счёта",
    "header.search_number_hint": "Введите номер NFT — # добавляется автоматически",
    "header.search_price_placeholder": "Цена NFT",
    "nav.dashboard": "Обзор",
    "nav.market": "Маркет",
    "nav.auctions": "Аукционы",
    "nav.rankings": "Рейтинги",
    "nav.owns": "Мои NFT",
    "nav.finance": "Финансы",
    "nav.settings": "Настройки",
    "header.search_placeholder": "Поиск NFT, коллекций…",
    "header.theme_toggle": "Сменить тему",
    "header.logout": "Выйти",
    "header.logout_failed": "Выход не подтверждён сервером. Сессия остаётся активной. Повторите попытку.",
    "header.open_menu": "Открыть меню",
    "header.close_menu": "Закрыть меню",
    "header.balance_title": "Доступный баланс",
    "header.pending_title": "Средства в обработке вывода"
  },
  en: {
    "header.search_mode": "Search by",
    "header.search_examples": "Search examples",
    "header.search_all": "All",
    "header.search_price": "Price",
    "header.search_number": "NFT number",
    "header.search_all_hint": "Collection name, price or #NFT number",
    "header.search_price_hint": "Enter a price in your account currency",
    "header.search_number_hint": "Enter an NFT number — # is added automatically",
    "header.search_price_placeholder": "NFT price",
    "nav.dashboard": "Overview",
    "nav.market": "Market",
    "nav.auctions": "Auctions",
    "nav.rankings": "Rankings",
    "nav.owns": "My NFTs",
    "nav.finance": "Finance",
    "nav.settings": "Settings",
    "header.search_placeholder": "Search NFTs, collections…",
    "header.theme_toggle": "Switch theme",
    "header.logout": "Log out",
    "header.logout_failed": "The server did not confirm logout. Your session is still active. Try again.",
    "header.open_menu": "Open menu",
    "header.close_menu": "Close menu",
    "header.balance_title": "Available balance",
    "header.pending_title": "Withdrawal in progress"
  },
  ua: {
    "header.search_mode": "Шукати за",
    "header.search_examples": "Приклади пошуку",
    "header.search_all": "Усе",
    "header.search_price": "Ціна",
    "header.search_number": "№ NFT",
    "header.search_all_hint": "Назва колекції, ціна або #номер NFT",
    "header.search_price_hint": "Введіть ціну у валюті рахунку",
    "header.search_number_hint": "Введіть номер NFT — # додається автоматично",
    "header.search_price_placeholder": "Ціна NFT",
    "nav.dashboard": "Огляд",
    "nav.market": "Маркет",
    "nav.auctions": "Аукціони",
    "nav.rankings": "Рейтинги",
    "nav.owns": "Мої NFT",
    "nav.finance": "Фінанси",
    "nav.settings": "Налаштування",
    "header.search_placeholder": "Пошук NFT, колекцій…",
    "header.theme_toggle": "Змінити тему",
    "header.logout": "Вийти",
    "header.logout_failed": "Сервер не підтвердив вихід. Сесія залишається активною. Спробуйте ще раз.",
    "header.open_menu": "Відкрити меню",
    "header.close_menu": "Закрити меню",
    "header.balance_title": "Доступний баланс",
    "header.pending_title": "Кошти в обробці виведення"
  },
  bl: {
    "header.search_mode": "Шукаць па",
    "header.search_examples": "Прыклады пошуку",
    "header.search_all": "Усё",
    "header.search_price": "Цана",
    "header.search_number": "№ NFT",
    "header.search_all_hint": "Назва калекцыі, цана або #нумар NFT",
    "header.search_price_hint": "Увядзіце цану ў валюце рахунку",
    "header.search_number_hint": "Увядзіце нумар NFT — # дадаецца аўтаматычна",
    "header.search_price_placeholder": "Цана NFT",
    "nav.dashboard": "Агляд",
    "nav.market": "Маркет",
    "nav.auctions": "Аўкцыёны",
    "nav.rankings": "Рэйтынгі",
    "nav.owns": "Мае NFT",
    "nav.finance": "Фінансы",
    "nav.settings": "Налады",
    "header.search_placeholder": "Пошук NFT, калекцый…",
    "header.theme_toggle": "Змяніць тэму",
    "header.logout": "Выйсці",
    "header.logout_failed": "Сервер не пацвердзіў выхад. Сесія застаецца актыўнай. Паспрабуйце яшчэ раз.",
    "header.open_menu": "Адкрыць меню",
    "header.close_menu": "Закрыць меню",
    "header.balance_title": "Даступны баланс",
    "header.pending_title": "Сродкі ў апрацоўцы вываду"
  },
  de: {
    "header.search_mode": "Suchen nach",
    "header.search_examples": "Suchbeispiele",
    "header.search_all": "Alle",
    "header.search_price": "Preis",
    "header.search_number": "NFT-Nummer",
    "header.search_all_hint": "Sammlungsname, Preis oder #NFT-Nummer",
    "header.search_price_hint": "Preis in Ihrer Kontowährung eingeben",
    "header.search_number_hint": "NFT-Nummer eingeben — # wird automatisch ergänzt",
    "header.search_price_placeholder": "NFT-Preis",
    "nav.dashboard": "Übersicht",
    "nav.market": "Markt",
    "nav.auctions": "Auktionen",
    "nav.rankings": "Ranglisten",
    "nav.owns": "Meine NFTs",
    "nav.finance": "Finanzen",
    "nav.settings": "Einstellungen",
    "header.search_placeholder": "NFTs, Sammlungen suchen…",
    "header.theme_toggle": "Design wechseln",
    "header.logout": "Abmelden",
    "header.logout_failed": "Der Server hat die Abmeldung nicht bestätigt. Ihre Sitzung ist weiterhin aktiv. Versuchen Sie es erneut.",
    "header.open_menu": "Menü öffnen",
    "header.close_menu": "Menü schließen",
    "header.balance_title": "Verfügbares Guthaben",
    "header.pending_title": "Auszahlung in Bearbeitung"
  },
  fr: {
    "header.search_mode": "Rechercher par",
    "header.search_examples": "Exemples de recherche",
    "header.search_all": "Tout",
    "header.search_price": "Prix",
    "header.search_number": "Numéro NFT",
    "header.search_all_hint": "Nom de collection, prix ou #numéro NFT",
    "header.search_price_hint": "Saisissez un prix dans la devise du compte",
    "header.search_number_hint": "Saisissez le numéro NFT — # est ajouté automatiquement",
    "header.search_price_placeholder": "Prix du NFT",
    "nav.dashboard": "Aperçu",
    "nav.market": "Marché",
    "nav.auctions": "Enchères",
    "nav.rankings": "Classements",
    "nav.owns": "Mes NFT",
    "nav.finance": "Finances",
    "nav.settings": "Paramètres",
    "header.search_placeholder": "Rechercher des NFT, collections…",
    "header.theme_toggle": "Changer de thème",
    "header.logout": "Déconnexion",
    "header.logout_failed": "Le serveur n’a pas confirmé la déconnexion. Votre session reste active. Réessayez.",
    "header.open_menu": "Ouvrir le menu",
    "header.close_menu": "Fermer le menu",
    "header.balance_title": "Solde disponible",
    "header.pending_title": "Retrait en cours de traitement"
  },
  cn: {
    "header.search_mode": "搜索方式",
    "header.search_examples": "搜索示例",
    "header.search_all": "全部",
    "header.search_price": "价格",
    "header.search_number": "NFT编号",
    "header.search_all_hint": "藏品集名称、价格或 #NFT编号",
    "header.search_price_hint": "输入账户币种的价格",
    "header.search_number_hint": "输入NFT编号，自动添加 #",
    "header.search_price_placeholder": "NFT价格",
    "nav.dashboard": "概览",
    "nav.market": "市场",
    "nav.auctions": "拍卖",
    "nav.rankings": "排行榜",
    "nav.owns": "我的NFT",
    "nav.finance": "财务",
    "nav.settings": "设置",
    "header.search_placeholder": "搜索NFT、藏品集…",
    "header.theme_toggle": "切换主题",
    "header.logout": "退出登录",
    "header.logout_failed": "服务器未确认退出。您的会话仍然有效，请重试。",
    "header.open_menu": "打开菜单",
    "header.close_menu": "关闭菜单",
    "header.balance_title": "可用余额",
    "header.pending_title": "提现处理中"
  }
});
